<template>
    <div>
        <!-- ヘッダー -->
        <div class="mb-4">
            <h2 class="fw-bold text-success mb-1">
                <i class="fa-solid fa-percent"></i>
                税区分マスタ
            </h2>
        </div>
        <div class="container" v-cloak>
            <div class="mb-3 text-end">
                <button class="btn btn-outline-secondary" @click="editCategory()">
                    <span class="fa-solid fa-plus"></span>
                    新規作成
                </button>
            </div>
            <div v-for="v in categories" :key="v.id" class="card mb-2">
                <div class="card-body d-flex justify-content-between align-items-center" :class="{'opacity-50': v.deleted_at}">
                    <div class="d-flex justify-content-start">
                        <div class="me-4">
                            <button class="btn btn-outline-secondary me-2"
                                @click="editCategory(v.id)"
                                :disabled="v.deleted_at">
                                <span class="fa-solid fa-pencil"></span>
                            </button>
                        </div>
                        <div class="me-4">
                            <div>
                                <span class="fs-5 fw-bold me-4">{{ v.name }}</span>
                            </div>
                            <div class="small">
                                <span class="me-4">
                                    <span class="badge bg-secondary">TKCコード</span>
                                    <span class="ms-1">{{ v.tkc_code }}</span>
                                </span>
                            </div>
                            <span v-if="v.deleted_at" class="badge bg-danger ms-2">削除済</span>
                        </div>
                    </div>
                    <div>
                        <button class="btn ms-3"
                            @click="toggle(v)"
                            :class="{'btn-outline-danger': !v.deleted_at, 'btn-outline-success': v.deleted_at}">
                            <span class="fa-solid fa-trash-can" v-if="!v.deleted_at"> 削除</span>
                            <span class="fa-solid fa-rotate-right" v-else> 復帰</span>
                        </button>
                    </div>
                </div>
            </div>
    
            <!-- 編集モーダル -->
            <tax-categories-editor
                :tax_category_id="tax_category_id"
                @saved="reload"
                @close="closeModal"
            />
        </div>
    </div>
</template>

<script>
import TaxCategoriesEditor from './taxCategoriesEditor.vue'
export default {
    components: { TaxCategoriesEditor },
    data() {
        return {
            tax_category_id: null,
            categories: [],
            modals: [],
        }
    },
    methods: {
        reload() {
            axios.get('/api/master/tax-categories').then(res => {
                this.categories = res.data
            }).catch(err => {Alert.err(err)});
        },
        editCategory(id = null) {
            this.tax_category_id = id;
            setTimeout(() => {
                this.modals['tax-category-editor'].show();
            });
        },
        closeModal(id) {
            this.modals[id]?.hide();
        },
        toggle(category) {
            let action = "削除";
            let dangerMode = true;
            let icon = "error";
            if (category.deleted_at) {
                action = "復帰";
                dangerMode = false;
                icon = "success";
            }
            swal({
                title: `税区分${action}`,
                text: `指定の税区分を${action}します。\nよろしいですか？`,
                icon: icon,
                dangerMode: dangerMode,
                buttons: ["キャンセル", action]
            }).then(confirm => {
                if (confirm) {
                    axios.post(`/api/master/tax-categories/${category.id}/toggle`).then(res => {
                        Alert.msg(res.data);
                    }).catch(err => {
                        Alert.err(err.response);
                    }).finally(() => this.reload());
                }
            });
        }
    },
    mounted() {
        this.modals['tax-category-editor'] = new bootstrap.Modal(document.getElementById('tax-category-editor'));
        this.reload()
    }
}
</script>
